import * as React from 'react'
import { SVGProps } from 'react'

const SvgHeartFilled = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512 473.13" {...props}>
    <path d="M471.9 39c-24.5-25.14-59.3-39-98.1-39C321 0 280.3 23 256 66.53 231.7 23 191 0 138.2 0 99.4 0 64.6 13.86 40.1 39 14.2 65.61.5 104 .5 149.89c0 54 41.4 123.55 123 206.62a1296.29 1296.29 0 0 0 119.8 106.92l12.7 9.7 12.7-9.8a1264 1264 0 0 0 119.8-106.91c81.6-83.08 123-152.57 123-206.63 0-45.79-13.7-84.18-39.6-110.79z" />
  </svg>
)

export default SvgHeartFilled
